import classNames from "classnames";
import ReactMarkdown from "react-markdown";
import remarkGemoji from "remark-gemoji";
import remarkGfm from "remark-gfm";
import "./SourcePreview.css";

interface Props {
    description: string;
    className?: string;
}

/** The source's own text, three lines behind a rule. */
export const SourcePreviewDescription = ({ description, className }: Props) => {
    return (
        <div className={classNames("wai-source-card-preview", className)}>
            <ReactMarkdown
                skipHtml
                remarkPlugins={[remarkGemoji, remarkGfm]}
                allowedElements={["p", "ul", "ol", "li"]}
                unwrapDisallowed
            >
                {description}
            </ReactMarkdown>
        </div>
    );
};
